<ion-header>
  <ion-toolbar>
    <ion-title>{{ name }}</ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="exit()" color="primary">
        <ion-icon name="close"/>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <pinch-zoom [autoHeight]="false" [backgroundColor]="'0xfff'">
    <img [src]="image | sharedSafe: 'url'" alt="image-view"/>
  </pinch-zoom>
</ion-content>
